module.exports = __webpack_public_path__ + "static/BigBang_UAU-5824d1de410a95516f594827479a6964.mp4";